<template>
  <div class="sum">
    <div class="mxr-cart-summary__backdrop" v-if="active && cartSize > 0"></div>
    <transition name="fade" mode="out-in">
      <cart-summary @mouseleave.native="hideSummary" v-if="active" class="mxr-cart-summary"></cart-summary>
    </transition>
    <div class="mxr-c-nav row expanded collapse align-middle align-justify">
      <div class="column shrink">
        <router-link to="/home" class="mxr-c-nav__logo">
          <img src="../assets/img/kalenji-by-decathlon.svg">
        </router-link>
      </div>
      <div class="column">
        <ul class="mxr-c-nav__menu menu horizontal align-center mxr-c-nav__menu--hascart">
          <li><router-link to="/looks/women">Donna</router-link></li>
          <li><router-link to="/looks/men">Uomo</router-link></li>
        </ul>
      </div>
      <div class="column shrink">
        <div class="show-summary-btn" @click="showSummary">
          <cart v-if="showCart"></cart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import cart from '@/components/Cart';
  import cartSummary from '@/components/CartSummary';
  import { mapGetters } from 'vuex';
  // import utils from '../utils';

  export default {
    name: 'navigation',
    components: {
      cart, cartSummary,
    },
    computed: {
      ...mapGetters({
        products: 'cartExport',
        cartSize: 'cartSize',
      }),
      showCart() {
        return this.$store.state.showCart;
      },
      exportURL() {
        const obj = {
          basket: {
            identifier: 'DressYourRun',
            products: this.products,
          },
        };
        return `https://www.decathlon.fr/fr/importExternalBasket?jsonString=${encodeURIComponent(JSON.stringify(obj))}`;
      },
    },
    methods: {
      showSummary() {
        // if (!utils.isTouchDevice()) {
        //   this.active = true;
        // }
        this.active = !this.active;
      },
      hideSummary() {
        /* if (!utils.isTouchDevice()) {
          this.active = false;
        } */
        this.active = false;
      },
    },
    data() {
      return {
        active: false,
      };
    },
    mounted() {
      this.$on('closeSummary', () => {
        this.showSummary();
      });
    },
  };
</script>

<style lang="scss" scoped>
  .show-summary-btn {
    cursor: pointer;
  }
  .mxr-cart-summary {
    overflow: scroll;
    background: $white;
    position: fixed;
    z-index: 200;
    width: 100%;
    top: 0;
    right: 0;
    font-size: rem-calc(14);
    padding: 1rem;
    bottom: rem-calc($nav-height-sm);
    @include breakpoint(large) {
      width: 50%;
      padding: rem-calc($borders-width-md);
    }
    @include breakpoint(medium) {
      bottom: rem-calc($nav-height);
    }
    &__backdrop {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      background: rgba(black, .7);
      animation: op ease-in-out .4s forwards;
      @at-root {
        @keyframes op {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      }
    }
  } 
  
  .mxr-c-nav {
    background: $black;
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 2;
    height: rem-calc($nav-height-sm);
    @include breakpoint(medium) {
      height: rem-calc($nav-height);
    }

    &__logo {
      background: $white;
      color: $black;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 0;
      height: rem-calc($nav-height-sm);
      width: rem-calc(60);
      img {
        max-width: 60%;
      }
      @include breakpoint(medium) {
        width: rem-calc(125);
        height: rem-calc($nav-height);
      }

      &:before {
        content: '';
        background: $white;
        height: 100%;
        width: 100%;
        right: 0;
        position: absolute;
        z-index: -1;
        transform: skewX(10deg);
        transform-origin: 0 0;
      }
    }

    &__menu {
      a {
        text-transform: uppercase;
        font-weight: $global-weight-bold;
        transition: all ease .4s;
        position: relative;
        font-size: rem-calc(12);
        letter-spacing: .311em;
        margin-right: rem-calc(-3.11); // disable letter spacing for last letter
        @include breakpoint(medium) {
          font-size: rem-calc(14);
          letter-spacing: .711em;
          margin-right: rem-calc(-7.11); // disable letter spacing for last letter
          &:before {
            content: '';
            height: rem-calc(4);
            width: rem-calc(4);
            background: $white;
            position: absolute;
            top: 100%;
            left: 50%;
            border-radius: 99em;
            margin-left: rem-calc(-7.11);
            transform: translateX(-50%);
            opacity: 0;
            transition: opacity ease .4s;
            margin-top: rem-calc(-2);
          }

          &.active {
            &:before {
              opacity: 1;
            }
          }
        }

        &:hover {
          letter-spacing: .611em;
          margin-right: -0.611em;
          @include breakpoint(medium) {
            letter-spacing: 1.2em;
            margin-right: -1.2em;
          }
        }
      }

      @include breakpoint(medium) {
        margin-right: rem-calc(125); // Compensate missing cart if showCart = false
      }

      li {
        display: flex;
        align-items: center;
        & + li {
          &:before {
            content: '';
            height: rem-calc(2);
            background: $white;
            width: rem-calc(2);
            @include breakpoint(medium) {
              width: rem-calc(62);
            }
          }
        }
      }
      &--hascart {
        margin-right: rem-calc(60);
        @include breakpoint(medium) {
          margin-right: rem-calc(125);
        }
      }
    }

    &__cart {
      background: $cart-yellow;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 0;
      position: absolute;
      top: 0;
      right: 0;
      width: rem-calc(60);
      height: rem-calc($nav-height-sm);
      @include breakpoint(medium) {
        width: rem-calc(125);
        height: rem-calc($nav-height);
      }

      &:before {
        content: '';
        background: $cart-yellow;
        height: 100%;
        width: 100%;
        left: 0;
        position: absolute;
        z-index: -1;
        transform: skewX(10deg);
        transform-origin: 100% 100%;
      }
    }

    &, a {
      color: $white;
    }
  }
</style>



// WEBPACK FOOTER //
// Navigation.vue?0e1369f6